import { Box, Button as MuiButton, Chip, Stack } from "@mui/material";
import { useNotify } from "react-admin";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import EmployeeInput from "server/components/Fields/EmployeeInput";
import { employeeRequests } from "api/employeeApi";
import { DEOS_STRUCTURAL_UNIT_ID } from "utils/constants";
import FormModal from "server/components/Modals/FormModal";

const LanguageCommitteeDialog = ({ campaignId, languageId, exam, onSaved }) => {
  const notify = useNotify();

  const defaultValues = {
    chairEmployeeId: exam?.chairEmployeeId ?? null,
    member1EmployeeId: exam?.member1EmployeeId ?? null,
    member2EmployeeId: exam?.member2EmployeeId ?? null,
  };

  const handleSave = async data => {
    const payload = {
      chairEmployeeId: data.chairEmployeeId ?? null,
      member1EmployeeId: data.member1EmployeeId ?? null,
      member2EmployeeId: data.member2EmployeeId ?? null,
    };
    await dataProvider.customRequest(doctoralRequests.setLanguageExamCommittee(campaignId, languageId), payload, "PUT");
    notify("Изпитната комисия е запазена", { type: "success" });
    if (onSaved) onSaved();
  };

  return (
    <FormModal
      triggerButton={
        <MuiButton
          size="small"
          variant="outlined"
          sx={{ whiteSpace: "nowrap", minWidth: "auto" }}
        >
          Изпитна комисия
        </MuiButton>
      }
      titleContent="Изпитна комисия по език"
      defaultValues={defaultValues}
      onConfirm={handleSave}
      dialogSize="md"
      saveTitle="Запази"
    >
      {exam?.hasCommittee && (
        <Box sx={{ mb: 1 }}>
          <Chip
            size="small"
            color="success"
            label="Избрана"
          />
        </Box>
      )}
      <Stack
        spacing={2}
        sx={{ mt: 1 }}
      >
        <EmployeeInput
          source="chairEmployeeId"
          label="Председател (от ДЕОС)"
          fullWidth
          filters={{ structuralUnitId: DEOS_STRUCTURAL_UNIT_ID }}
          reference={employeeRequests.getEmployeesWithDegreeSelect()}
        />
        <EmployeeInput
          source="member1EmployeeId"
          label="Член 1 (от ДЕОС)"
          fullWidth
          filters={{ structuralUnitId: DEOS_STRUCTURAL_UNIT_ID }}
          reference={employeeRequests.getEmployeesWithDegreeSelect()}
        />
        <EmployeeInput
          source="member2EmployeeId"
          label="Член 2 (от ДЕОС)"
          fullWidth
          filters={{ structuralUnitId: DEOS_STRUCTURAL_UNIT_ID }}
          reference={employeeRequests.getEmployeesWithDegreeSelect()}
        />
      </Stack>
    </FormModal>
  );
};

export default LanguageCommitteeDialog;
